
import moment from 'moment'
moment.locale('pt-br')

export default moment
